import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import {
  ConsistancyChamp,
  BodyProgressHero,
  BalancedPerformer,
  LockSleepCoach,
} from "@utils/defaultImages";
import stepBack from "@assets/images/stepsBack.jpg";
import { Card } from "@mui/material";
import { ChevronLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { fetchWeeklyRanks } from "@api/weeklyTracker";
import ActualDietPlanLoader from "@components/ui/Loaders/ActualDietPlanLoader";
const RanksWeekly = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [firstLoad, setFirstLoad] = useState(true);

  const [badgeAchived, setBadgeAchived] = useState(null);

  const sliderData = [
    {
      RankImage: ConsistancyChamp,
      title: "Consistency Champ",
      unlockDate: "Unlocked on 5th July",
      description:
        "Earned for logging your weekly check-in three weeks in a row.",
    },
    {
      RankImage: BodyProgressHero,
      title: "Body Progress Hero",
      unlockDate: "Unlocked on 5th July",
      description:
        "Unlocked when you achieve measurable improvement in Weight, Body Fat %, or Waist for 3 consecutive weeks.",
    },
    {
      RankImage: BalancedPerformer,
      title: "Balanced Performer",
      unlockDate: "Unlocked on 5th July",
      description:
        "Awarded when your Sleep, Energy, Stress, and Motivation scores all stay above 4 for a week.",
    },
  ];

  const fetchRanksData = async () => {
    try {
      const response = await fetchWeeklyRanks();
      const data = response.data;
      setBadgeAchived(data);
    } catch (error) {
      console.log("error getting ranks:", error);
    } finally {
      setFirstLoad(false);
    }
  };

  useEffect(() => {
    fetchRanksData();
  }, []);

  const achievedMilestones = sliderData?.filter((data) =>
    badgeAchived?.find((badge) => badge?.title === data.title),
  );
  const unachievedMilestones = sliderData?.filter(
    (data) => !badgeAchived?.find((badge) => badge?.title === data.title),
  );

  const renderMilestoneSlider = (data, isAchieved, title, uniqueId) => (
    <div
      className="
    mb-6
    [@media(max-width:639px)]:!max-w-[70vw]
    sm:max-w-[100%]
  "
    >
      <h5 className="text-[16px] font-[Lato] text-white mb-3 ml-2">{title}</h5>
      <Swiper
        modules={[Navigation]}
        spaceBetween={20}
        slidesPerView={1}
        breakpoints={{
          0: { slidesPerView: 1 },
          700: { slidesPerView: 2, spaceBetween: 15 },
          1024: { slidesPerView: 2, spaceBetween: 20 },
          1280: { slidesPerView: 3, spaceBetween: 20 },
        }}
        navigation={{
          nextEl: `.swiper-button-next-${uniqueId}`,
          prevEl: `.swiper-button-prev-${uniqueId}`,
        }}
        className="all-meals !px-[22px] sm:!px-[20px] !py-[25px] rounded-[10px] relative"
      >
        {/* Custom navigation buttons */}
        <div
          className={`swiper-button-prev-${uniqueId} swiper-button-prev after:!text-[20px] after:!font-[600] !bg-white !rounded-full !w-9 !h-9 sm:!w-10 sm:!h-10 !flex !items-center !justify-center !shadow-md after:!text-[#0575e6] absolute top-1/2 !-left-0 z-10`}
        ></div>
        <div
          className={`swiper-button-next-${uniqueId} swiper-button-next !bg-white after:!text-[20px] after:!font-[600] !rounded-full !w-9 !h-9 sm:!w-10 sm:!h-10 !flex !items-center !justify-center !shadow-md after:!text-[#0575e6] absolute top-1/2 !-right-0 z-10`}
        ></div>

        {data?.map((item, index) => {
          const isLocked = isAchieved;
          const unlockDate = badgeAchived?.[item.title]?.unlockDate || null;

          return (
            // 1. Add !h-auto to SwiperSlide
            <SwiperSlide key={index} className="!h-auto">
              {/* 2. Use flex-col and h-full on wrapper */}
              <div className="flex flex-col justify-center w-full h-full relative">
                <div
                  className={`${
                    !isLocked && "blur-[8px]"
                  } bg-white rounded-3xl w-full max-w-[80%] p-5 relative pb-8 mx-auto flex flex-col h-full`}
                >
                  {/* 3. Content Container with flex-grow */}
                  <div className="flex-grow flex flex-col justify-between">
                    <div className="flex justify-center">
                      <h3
                        className={`text-[#000] text-[12px] sm:text-[16px] font-[600] font-[Lato] mt-[30%] text-center`}
                      >
                        {t(item?.title)}
                      </h3>
                    </div>

                    <div className="flex justify-center">
                      {isLocked && (
                        <button
                          disabled
                          className="bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] rounded-[22px] py-2 px-3 text-[10px] sm:text-[12px] my-2 text-white"
                        >
                          {!isLocked
                            ? t("quizGame.Locked")
                            : t("quizGame.Unlocked")}
                        </button>
                      )}
                    </div>

                    {/* 4. Description box with mb-auto to push content */}
                    <div className="border border-[#DDDDDD] p-2 rounded-xl mb-auto">
                      <p className="text-[10px] md:text-[12px] text-[#5C5C5C] text-center">
                        {t(item.description)}
                      </p>
                    </div>
                  </div>

                  <img
                    src={item.RankImage}
                    alt="image"
                    className="absolute -top-[8%] left-1/2 -translate-x-1/2 z-[9] w-[40%] object-cover"
                    style={{ maxHeight: "none" }}
                  />
                </div>

                {!isLocked && (
                  <img
                    src={LockSleepCoach}
                    alt="image"
                    className="absolute top-[40%] 2xl:top-[30%] left-1/2 -translate-x-1/2 z-[10] object-cover w-[40px] sm:w-[50px]"
                  />
                )}
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );

  return (
    <>
      {firstLoad ? (
        <ActualDietPlanLoader weeklyTracker={true} />
      ) : (
        <>
          <div className="flex justify-end">
            <button
              className="bg-[#64DDFF] py-[12px] px-6 text-white rounded-full  mb-2 flex items-center gap-2"
              onClick={() => navigate(-1)}
            >
              <ChevronLeft
                className="w-6 h-6 bg-white rounded-full text-[#4CDBFF] p-[2px]"
                strokeWidth={4}
              />
              {t("quizGame.Return To Dashboard")}
            </button>
          </div>
          <Card className="p-5 !rounded-xl">
            {/* Milestones Section */}
            <div
              className="p-6 w-full rounded-xl text-white bg-cover h-full relative flex flex-col items-center sm:block "
              style={{ backgroundImage: `url(${stepBack})` }}
            >
              {/* <h4 className="text-[16px] font-[Lato] text-white mb-6">
              Your Milestones
            </h4> */}

              {/* Achieved Milestones */}
              {achievedMilestones?.length > 0 &&
                renderMilestoneSlider(
                  achievedMilestones,
                  true,
                  t("quizGame.Your Achieved Milestones"),
                  "milestone-achieved",
                )}

              {/* Unachieved Milestones */}
              {unachievedMilestones?.length > 0 &&
                renderMilestoneSlider(
                  unachievedMilestones,
                  false,
                  t("quizGame.Milestones Yet to Achieve"),
                  "milestone-unachieved",
                )}
            </div>
          </Card>
        </>
      )}
    </>
  );
};

export default RanksWeekly;
